import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse, AuthState } from "models";

const initialState: AuthState = {
  isLoggedIn: false,
  loading: false,
  currentUser: {},
  message: "",
  success: false,
  resendOtpSuccess: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resendOtp(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
      state.success = false;
    },
    resendOtpSuccess(state, action: PayloadAction<ApiResponse>) {
      state.isLoggedIn = true;
      state.resendOtpSuccess = true;
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    resendOtpFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.success = action.payload.success;
      state.message = action.payload.message;
    },
    resetResendOtpState(state) {
      state.resendOtpSuccess = false;
      state.message = "";
    },
    login(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    loginSuccess(state, action: PayloadAction<ApiResponse>) {
      state.isLoggedIn = true;
      state.loading = false;
      state.success = action.payload.success;
      state.currentUser = action.payload.data;
      state.message = action.payload.message;
    },
    loginFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.success = action.payload.success;
      state.message = action.payload.message;
    },
    logout(state, action: PayloadAction<ApiResponse>) {
      state.success = false;
      state.loading = false;
      state.message = "";
    },
    logoutSuccess(state, action: PayloadAction<ApiResponse>) {
      state.isLoggedIn = false;
      state.currentUser = {};
      state.success = action.payload.success;
      state.message = action.payload.message;
    },
    logoutFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.success = action.payload.success;
      state.message = action.payload.message;
    },
    clearData(state) {
      state.isLoggedIn = false;
      state.loading = false;
      state.message = "";
      state.success = false;
      state.resendOtpSuccess = false;
    },
  },
});

// Actions
export const authActions = authSlice.actions;

// Selectors
export const selectIsLoggedIn = (state: RootState) => state.auth.isLoggedIn;
export const selectIsLogging = (state: RootState) => state.auth.loading;
export const selectUserData = (state: RootState) => state.auth.currentUser;
export const selectMessage = (state: RootState) => state.auth.message;

// Reducer
const authReducer = authSlice.reducer;
export default authReducer;
